import { createSlice } from '@reduxjs/toolkit';
import { initialState } from '../defaultState';

const movieOverlayScreenSlice = createSlice({
    name: 'Config',
    initialState: initialState.movieOverlay,
    reducers: {
        movieOverlaySetVisible: (state) => {
            state.isVisible = true;
        },
        movieOverlaySetInVisible: (state) => {
            state.isVisible = false;
        },
        catchupOverlaySetVisible: (state) => {
            state.isCatchupVisible = true;
        },
        catchupverlaySetInVisible: (state) => {
            state.isCatchupVisible = false;
        },
        ppvOverlaySetVisible: (state) => {
            state.isPpvVisible = true;
        },
        ppvOverlaySetInVisible: (state) => {
            state.isPpvVisible = false;
        },
    },
});

export const {
    movieOverlaySetVisible,
    movieOverlaySetInVisible,
    catchupOverlaySetVisible,
    catchupverlaySetInVisible,
    ppvOverlaySetVisible,
    ppvOverlaySetInVisible,
} = movieOverlayScreenSlice.actions;

export default movieOverlayScreenSlice.reducer;
